import { CardDeckPreview } from "../../shared/interfaces/GameLogicTypes";

export function sortDecks(deck1: CardDeckPreview, deck2: CardDeckPreview) {
  if (deck1.featured !== deck2.featured) return deck1.featured ? -1 : 1;
  const score1 = (deck1.playCount ?? 0) * 2 + deck1.categoriesCount;
  const score2 = (deck2.playCount ?? 0) * 2 + deck2.categoriesCount;
  if (score1 !== score2) return score2 - score1;
  return deck1.name.localeCompare(deck2.name);
}
